"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
require("core-js/modules/web.dom.iterable");
var _singleShipBlock = require("@/api/system/singleShipBlock");
var _lang = _interopRequireDefault(require("@/lang"));
var _elementUi = require("element-ui");
var state = {
  config: {},
  //配置项
  isShowPenel: true,
  //是否隐藏该模块
  isMustModify: false,
  isShowOptionAdd: false,
  isShowOptionEdit: false,
  editPanel: {},
  // 当前编辑的模块
  mainBlock: [] // 主模块
};
var dictCode = {
  SHORE_BLOCK_CODE_DICT: "BANK_SINGLE_SHIP_BLOCK",
  SHORE_BLOCK_TYPE_CODE_DICT: "BANK_SINGLE_SHIP_BLOCK_TYPE"
};
var APPLY_TYPE = "3";
var mutations = {
  /** 获取配置 */
  GET_CONFIG: function GET_CONFIG(state, config) {
    state.config = config;
  },
  /**隐藏模块 */
  HIDE_MODULE: function HIDE_MODULE(state, delPanel) {
    console.log('执行了隐藏==', delPanel);
    var index = delPanel.index,
      side = delPanel.side;
    if (side === 'L') {
      state.config.leftSide.splice(index, 1);
    } else if (side === 'R') {
      state.config.rightSide.splice(index, 1);
    }
  },
  /** 添加模块 */
  ADD_MODULE: function ADD_MODULE(state, addPanel) {
    if (addPanel.leftRightInd === 'L') {
      state.config.leftSide.push(addPanel);
    } else if (addPanel.leftRightInd === 'R') {
      state.config.rightSide.push(addPanel);
    }
  },
  /* 显示新增弹窗 */
  SHOW_OPTION_ADD: function SHOW_OPTION_ADD(state, bol) {
    state.isShowOptionAdd = bol;
  },
  /* 当前编辑的模块 */
  EDIT_PANEL: function EDIT_PANEL(state, block) {
    state.editPanel = block;
  },
  /* 显示编辑弹窗 */
  SHOW_OPTION_EDIT: function SHOW_OPTION_EDIT(state, bol) {
    state.isShowOptionEdit = bol;
  },
  /* 编辑修改位置 */
  EDIT_MODULE: function EDIT_MODULE(state, block) {
    console.log(block);
    // if(state.editPanel. === block.){}
  },
  /** 移动模块 */
  MOVE_BLOCK: function MOVE_BLOCK(state, block) {
    var side = block.side,
      index = block.index,
      seq = block.seq;
    if (side === 'right') {
      state.config.rightSide[index].leftRightInd = 'R';
      state.config.rightSide[index].seq = seq;
    } else {
      state.config.leftSide[index].leftRightInd = 'L';
      state.config.leftSide[index].seq = seq;
    }
    console.log('执行了移动逻辑==', block, state.config);
  },
  /* 主模块 array */
  GET_MAIN_BLOCK: function GET_MAIN_BLOCK(state, arr) {
    state.mainBlock = arr;
  }
};
var actions = {
  /** 获取配置 */getConfig: function getConfig(_ref) {
    var commit = _ref.commit,
      rootGetters = _ref.rootGetters;
    //如果要上船要判断船岸 岸3 船4
    var data = {
      applyType: '3'
    };
    var config = {
      leftSide: [],
      rightSide: []
    };
    (0, _singleShipBlock.getBlock)(data).then(function (res) {
      if (res.success) {
        var list = res.data;
        list.forEach(function (item) {
          if (item.showFlag) {
            // 过滤掉隐藏项
            switch (item.leftRightInd) {
              case 'L':
                config.leftSide.push(item);
                break;
              case 'R':
                config.rightSide.push(item);
                break;
            }
          }
        });
        /* 排序 */
        config.leftSide.sort(function (a, b) {
          return a.seq - b.seq;
        });
        config.rightSide.sort(function (a, b) {
          return a.seq - b.seq;
        });
        commit('GET_CONFIG', config);
      }
    }, function (err) {
      console.log(err);
    });
  },
  /** 隐藏 */hideModule: function hideModule(_ref2, delPanel) {
    var commit = _ref2.commit,
      rootGetters = _ref2.rootGetters;
    var data = {
      id: delPanel.block.id
    };
    (0, _singleShipBlock.deleteBlock)(data).then(function (res) {
      if (res.success) {
        commit('HIDE_MODULE', delPanel);
      }
      console.log(res);
    }, function () {
      (0, _elementUi.Message)({
        message: '操作失败',
        type: 'error'
      });
    });
  },
  /* 显示/隐藏添加区块 */showAddModule: function showAddModule(_ref3, bol) {
    var commit = _ref3.commit;
    commit('SHOW_OPTION_ADD', bol);
  },
  /* 添加区块 */addModule: function addModule(_ref4, form) {
    var commit = _ref4.commit;
    return new Promise(function (resolve, reject) {
      (0, _singleShipBlock.saveBlock)(form).then(function (res) {
        if (res.success) {
          commit('ADD_MODULE', res.data);
        }
        resolve(res);
      }, function (err) {
        reject(err);
      });
    });
  },
  /* 显示/隐藏编辑区块 */showEditModule: function showEditModule(_ref5, bol) {
    var commit = _ref5.commit;
    commit('SHOW_OPTION_EDIT', bol);
  },
  /* 更新区块 */editModule: function editModule(_ref6, form) {
    var commit = _ref6.commit;
    return new Promise(function (resolve, reject) {
      (0, _singleShipBlock.updateBlock)(form).then(function (res) {
        resolve(res);
      }, function (err) {
        reject(err);
      });
    });
  },
  /* 恢复默认 */recover: function recover(_ref7) {
    var dispatch = _ref7.dispatch,
      rootGetters = _ref7.rootGetters;
    //如果要上船要判断船岸 岸3 船4
    var data = {
      applyType: '3'
    };
    (0, _singleShipBlock.restoreBlock)(data).then(function (res) {
      if (res.success) {
        dispatch('getConfig');
      }
    });
  },
  /** 移动 */movePanel: function movePanel(_ref8, block) {
    var state = _ref8.state,
      commit = _ref8.commit;
    var side = block.side,
      index = block.index;
    var newIndex = index !== 0 ? state.config[side === 'right' ? 'rightSide' : 'leftSide'][index - 1].seq + 1 : 0;
    var data = {
      id: state.config[side === 'right' ? 'rightSide' : 'leftSide'][index].id,
      leftRightInd: side === 'right' ? 'R' : 'L',
      seq: newIndex,
      applyType: APPLY_TYPE
    };
    block.seq = newIndex;
    commit('MOVE_BLOCK', block);
    return new Promise(function (resolve, reject) {
      (0, _singleShipBlock.updateSysUserBlock)(data).then(function (res) {
        if (res.success) {
          resolve(res);
        } else {
          reject(res);
        }
      }, function (err) {
        resolve(err);
      });
    });
  },
  /* 操作栏事件 */optionPanel: function optionPanel(_ref9, option) {
    var commit = _ref9.commit,
      dispatch = _ref9.dispatch;
    switch (option.type) {
      case 'edit':
        commit('EDIT_PANEL', {
          block: option.block,
          index: option.index,
          side: option.side
        });
        dispatch('showEditModule', true);
        break;
      case 'addModule':
        dispatch('showAddModule', true);
        break;
      case 'hidden':
        dispatch('hideModule', {
          block: option.block,
          index: option.index,
          side: option.side
        });
        break;
      case 'recover':
        _elementUi.MessageBox.confirm(_lang.default.t('tips.restoreTips'), _lang.default.t('tips.restoreTips1'), {
          confirmButtonText: _lang.default.t('tips.restoreTips2'),
          cancelButtonText: _lang.default.t('tips.restoreTips3'),
          type: 'warning'
        }).then(function () {
          dispatch('recover');
        });
        break;
      default:
        break;
    }
  },
  /* 获取主模块 */getMainBlock: function getMainBlock(_ref10) {
    var commit = _ref10.commit,
      state = _ref10.state,
      rootGetters = _ref10.rootGetters;
    return new Promise(function (resolve, reject) {
      if (state.mainBlock.length !== 0) {
        resolve(state.mainBlock);
      } else {
        //如果要上船dictCode要根据船岸取不同的
        var data = {
          blockCodeDict: dictCode.SHORE_BLOCK_CODE_DICT
        };
        (0, _singleShipBlock.getBlockCodeByBlockCodeDict)(data).then(function (res) {
          if (res.success) {
            var _data = res.data;
            commit('GET_MAIN_BLOCK', _data);
            resolve(_data);
          }
        }).catch(function (err) {
          reject(err);
        });
      }
    });
  },
  /* 获取子模块 */getChildBlock: function getChildBlock(_ref11, blockCode) {
    var rootGetters = _ref11.rootGetters;
    return new Promise(function (resolve, reject) {
      //如果要上船dictCode要根据船岸取不同的
      var data = {
        blockTypeCodeDict: dictCode.SHORE_BLOCK_TYPE_CODE_DICT,
        blockCode: blockCode
      };
      (0, _singleShipBlock.getSysUserBlockByBlockCode)(data).then(function (res) {
        if (res.success) {
          var _data2 = res.data;
          resolve(_data2);
        } else {
          reject(res);
        }
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  //命名空间
  state: state,
  mutations: mutations,
  actions: actions
};